module.exports = __webpack_public_path__ + "media/images/icons/icn_012-6c6f5f4ee6f65f00a0414a3e799ead22.svg";